/* Action Types */
export const LOAD_UPCOMING_ITEMS_FAIL = 'la/upcoming-items/FAIL';
export const LOAD_UPCOMING_ITEMS_REQUEST = 'la/upcoming-items/REQUEST';
export const LOAD_UPCOMING_ITEMS_SUCCESS = 'la/upcoming-items/SUCCESS';
